(() => {
  if (window.baesicVehicleGridReady) return;
  window.baesicVehicleGridReady = true;
  const subgrid = CSS.supports('grid-template-rows', 'subgrid');
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('.nav-catalog .collection-list').forEach(grid => {
      const cards = [...grid.querySelectorAll(':scope > .collection-card')].filter(card => !card.hidden);
      if (subgrid && getComputedStyle(grid).display === 'grid') return;
      const rows = new Map();
      cards.forEach(card => {
        const frame = card.querySelector('.image-wrapper');
        if (!frame) return;
        const ratio = parseFloat(getComputedStyle(frame).getPropertyValue('--vehicle-image-ratio')) || 1.5;
        const cap = parseFloat(getComputedStyle(frame).getPropertyValue('--vehicle-height-cap')) || 320;
        const key = Math.round(card.offsetTop);
        if (!rows.has(key)) rows.set(key, []);
        rows.get(key).push({frame,height:Math.min(frame.clientWidth / ratio,cap)});
      });
      rows.forEach(row => {
        const height = Math.max(...row.map(item => item.height));
        row.forEach(({frame}) => { frame.style.height = height + 'px'; });
      });
    });
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  const resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  const initialize = () => {
    document.querySelectorAll('.nav-catalog .collection-list').forEach(grid => resize?.observe(grid));
    schedule();
  };
  document.addEventListener('load', event => { if (event.target.matches?.('.nav-catalog img')) schedule(); }, true);
  document.addEventListener('baesic:vehicle-ratios', schedule);
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('resize', schedule, {passive:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
